import type { R2WCOptions } from '@r2wc/core';
import r2wc from '@r2wc/react-to-web-component';
import { lightTheme } from '~/theme.css';

// If you decide to add SWRConfig
// import { SWRConfig, type SWRConfiguration } from 'swr';
// const config: SWRConfiguration = {
//   revalidateOnMount: true,
//   revalidateOnFocus: false,
//   revalidateOnReconnect: false,
//   focusThrottleInterval: 1000,
// };
// <SWRConfig value={config}></SWRConfig>

const registerComponent = <P extends Record<string, unknown>>(
  Component: React.ComponentType<P>,
  name: string,
  props: NonNullable<R2WCOptions<P>['props']>
) => {
  if (!customElements.get(name)) {
    customElements.define(
      name,
      r2wc(
        (componentProps: Record<string, unknown>) => (
          <span style={{ fontFamily: 'var(--font)' }} className={lightTheme} data-theme="light">
            <Component {...(componentProps as P)} />
          </span>
        ),
        {
          props,
        }
      )
    );
  }
};

export default registerComponent;
